import request from '@/common/request'
import file from '@/common/fileDownload'

export default {
  queryOperateRecord: params => {
    return request({
      url: '/operateRecord',
      method: 'get',
      params
    })
  },
  exportOperateRecord: params => {
    return request({
      url: '/operateRecord/export',
      method: 'get',
      params
    })
  },
  operateRecordDownload: params=>{
    let fileUrl = '/file/'+params
    file.fileDownload(fileUrl, null);
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/operateRecord.js